exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-04a5e666] .drawer{max-height:100vh;height:100vh;margin:0;transition:transform .5s}[data-v-04a5e666] .none-enter-to{transform:translateX(0)}[data-v-04a5e666] .none-enter-active,[data-v-04a5e666] .none-leave-active{transform:translateX(100%)}.v-dialog__content[data-v-04a5e666]{justify-content:flex-end;border-radius:0}.inactive-warning[data-v-04a5e666]{font-size:12px;color:#f44336}", ""]);

// exports
